import React from 'react';
import { PropTypes } from 'prop-types';
// styles
import styled, { css } from 'styled-components';
//
import {
  CheckCircleFullIcon,
  EmptyCircleIcon,
  LockIcon,
} from 'refactored/ui/icons';

const Input = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;

  width: 100%;
  height: 48px;

  /* secondary / white */

  /* background: #ffffff; */
  /* background: red; */
  /* grey / 300 */

  border-width: 1px 1px 1px 4px;
  border-style: solid;
  border-color: #ccd6e0;
  border-radius: 4px;
  overflow: hidden;
  ${(props) =>
    !!props.isSelected &&
    css`
      border-radius: 0;
    `};

  cursor: pointer;
  ${(props) =>
    !!props.isDisabled &&
    css`
      cursor: default;
    `};
`;

const IconContainer = styled.div`
  /* Auto layout */

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;Input
  padding: 8px;
  gap: 10px;

  width: 48px;
  height: 48px;

  /* grey / 100 */

  background: #f2f5f8;
  ${(props) =>
    !!props.isDisabled &&
    css`
      background: var(--grey200);
    `};
  /* grey / 300 */

  /* border-width: 1px 0px 1px 4px;
  border-style: solid;
  border-color: #ccd6e0;
  border-radius: 4px 0px 0px 4px; */
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 12px;
  gap: 12px;

  width: 520px;
  height: 48px;

  /* secondary / white */

  background: #ffffff;
  ${(props) =>
    !!props.isDisabled &&
    css`
      background: var(--grey100);
    `};
  /* grey / 300 */

  border-width: 1px 1px 1px 0px;
  border-style: solid;
  border-color: #ccd6e0;
  border-radius: 0px 4px 4px 0px;
  border: none;
  justify-content: space-between;
`;

const Label = styled.div`*/
font-family: 'Roboto';
font-style: normal;
font-weight: 400;
font-size: 16px;
line-height: 24px;
/* identical to box height, or 150% */

display: flex;
align-items: center;

/* grey / 700 */

color: #54708C;
`;

const CollapsableContent = styled.div`
  /* margin-top: 20px; */
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px 12px 16px 16px;
  gap: 8px;

  /* width: 568px; */
  /* height: 80px; */

  /* grey / 100 */

  background: #f2f5f8;
  /* grey / 300 */

  border-width: 0px 1px 1px 4px;
  border-style: solid;
  border-color: #ccd6e0;
  border-radius: 0px 0px 4px 4px;

  /* border: 1px solid red; */
`;

const SoFormCollapsableInput = ({
  className,
  icon,
  label,
  children,
  isSelected,
  setIsSelected,
  isDisabled = false,
}) => {
  return (
    <div className={className}>
      <Input
        isDisabled={isDisabled}
        isSelected={isSelected}
        onClick={() => {
          if (isDisabled) return;
          return setIsSelected(!isSelected);
        }}
      >
        <IconContainer isDisabled={isDisabled}>{icon}</IconContainer>
        <TextContainer isDisabled={isDisabled}>
          <Label>{label}</Label>
          {!isDisabled &&
            (isSelected ? <CheckCircleFullIcon /> : <EmptyCircleIcon />)}
          {isDisabled && <LockIcon />}
        </TextContainer>
      </Input>
      {isSelected && !isDisabled && (
        <CollapsableContent>{children}</CollapsableContent>
      )}
    </div>
  );
};

SoFormCollapsableInput.propTypes = {
  className: PropTypes.string,
};

export default styled(SoFormCollapsableInput)`
  display: flex;
  flex-direction: column;
  width: 100%;
  ${(props) =>
    !!props.isDisabled &&
    css`
      cursor: disabled;
    `};
`;
